import React, { useState } from "react";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";

interface Props {
  url: string;
  className?: string;
}
const ImageView = (props: Props) => {
  const { url, className = "" } = props;

  return (
    <PhotoProvider maskOpacity={0.8} loop={false} photoClosable>
      <div className={className}>
        <PhotoView src={url}>
          <img src={url} alt="" />
        </PhotoView>
      </div>
    </PhotoProvider>
  );
};

export default ImageView;
